/* src/app/admin/audit-log/audit-log-result/values/audit-request.component.scss */
.audit-request-table {
  margin-bottom: 30px;
}
/*# sourceMappingURL=audit-request.component-IU7OXA64.css.map */
